import { getDefined } from '../defined';
import { createUrlBuilder } from './buildUrl';

export const getPublicAsset = createUrlBuilder(
  getDefined('PUBLIC_AGENTS_BASE_PATH') ?? '',
);
